
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class LowerRightCorner extends Vue {
  @Prop({ type: Boolean, default: false }) dataAllReady!: boolean; //数据是否加载完成
  pdfIng = false; //下载pdf中
  //跳转
  toScroll(to: string) {
    const parent = this.$parent;
    if (parent) {
      if (!parent.$refs[to] || this.pdfIng) {
        return;
      }
      (parent.$refs[to] as HTMLElement).scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
}
